import { GeneralErrorBoundary } from '#app/components/error-boundary.tsx'
import { type Route } from './+types/index.ts'

export default function UsersRoute({}: Route.ComponentProps) {
	return (
		<div className='container mt-36 mb-48 flex flex-col items-center justify-center gap-6'>
			<h1 className='text-h1'>Themelio Base Stack Users</h1>
			<main>Users</main>
		</div>
	)
}

export function ErrorBoundary() {
	return <GeneralErrorBoundary />
}
